module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Stainless Steel + Black Leather Closed.86ae7e77.png";